// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import ContentBox from 'components/ContentBox/ContentBox'

class Posts extends React.Component {
	render() {
		const { page } = this.props

		if ( ! page ) {
			return null
		}

		const postsMarkup = page.posts.items ? page.posts.items.map( ( e, i ) => {
			return (
				<div className="-area -col-12" key={ i }>
					<article className="tile">
						<div className="content-box -with-link">
							<Link to={ e.url }>
								<div className="-text -col-6">
									<h3 dangerouslySetInnerHTML={ { __html: e.title } }></h3>
									<span className="-sub">{ e.date }</span>

									<div className="-text-wrap" dangerouslySetInnerHTML={ { __html: e.excerpt } }></div>
								</div>
							</Link>

							{ e.image_url &&
								<img className="-bg-right-cover" src={ e.image_url } alt="" />
							}
						</div>
					</article>
				</div>
			)
		}) : ''

		const { pathname } = this.props.location
		const { archivePageNumber } = this.props.match.params
		const postsPaginationMarkup = page.posts.max_num_pages ? [ ...Array( page.posts.max_num_pages ) ].map( ( e, i ) => {
			i++
			var className = archivePageNumber == i ? 'button -page is-active' : 'button -page'
			var newPath

			if ( pathname.match( /page\/\d+\//g ) ) {
				newPath = pathname.replace( /page\/\d+\//g, 'page/' + i + '/' )
			} else {
				newPath = pathname + '/page/' + i
			}

			return (
				<Link to={ newPath } className={ className } key={ i }>
					{ i }
				</Link>
			)
		}) : ''

		const posts = postsMarkup.length ? (
			<div className="posts tiles">
				{ postsMarkup }
			</div>
		) : ''

		const postsPagination = postsPaginationMarkup.length ? (
			<div className="pagination">
				<h3>View Previous</h3>

				{ postsPaginationMarkup }
			</div>
		) : ''

		return (
			<div>
				{ posts }
				{ postsPagination }
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Posts )



// WEBPACK FOOTER //
// ./views/main/page/Posts.jsx